@if (tabs) {
  <app-tabs
    [tabs]="tabs">
  </app-tabs>
}

<br>

  <app-list-header
    name="session"
    [canCreate]="false"
    (onSearch)="search($event)">
  </app-list-header>

  <app-item-list
    [columns]="columns"
    [actions]="actions"
  [icons]="[
  { name: 'headset text--blink red', visible: isCurrentSession },
  { name: 'vr-cardboard text--md', visible: isDeviceSession }
  ]"
    [items$]="sessions$"
    [clickable]="false"
    (onChangePage)="changePage($event.pageIndex, $event.pageSize)">
  </app-item-list>

  @if (isLoading) {
    <app-loader [transparent]="true"></app-loader>
  }

